import React, { useRef, useState } from 'react';
import { useSnackbar } from 'material-ui-snackbar-provider';
import { useHistory } from 'react-router-dom';

import { getSubGroupsByGroupIdThunk } from '../../../store/subGroups/subGroupsSlice';
import { ContainedButton, OutlinedButton } from '../../modules/Buttons';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { patchGroupAnalysts } from '../../../api/groupsApi';
import styles from './DeleteAnalystModal.module.scss';
import { NOTIFICATION } from '../../../enums/ENUMS';
import { findSearchValue } from '../../../helpers';
import { useHotkeys } from 'react-hotkeys-hook';
import Modal from '../../modules/Modal';

type TDeleteAnalystModal = {
  id: string;
  open: boolean;
  switchModal: () => void;
  subgroup?: boolean;
};

const DeleteAnalystModal: React.FC<TDeleteAnalystModal> = ({ id, open, switchModal, subgroup }) => {
  const notification = useSnackbar();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const submitButtonRef = useRef<HTMLDivElement>(null);
  const { sort, sortOption } = useAppSelector((state) => state.subGroupsStore);

  const [loading, setLoading] = useState(false);
  const handleDelete = async () => {
    setLoading(true);
    try {
      // await patchGroupAnalysts(history.location.state as string, { analystsToRemove: [id] });
      await patchGroupAnalysts(subgroup ? (findSearchValue('subgroupId') as string) : (history.location.state as string), {
        usersToRemove: [id],
      });
      switchModal();
      dispatch(getSubGroupsByGroupIdThunk({ groupId: history.location.state as string, sort, sortOption }));
    } catch (err) {
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err?.response?.data?.message);
      } else {
        notification.showMessage(NOTIFICATION.NOT_DELETED);
      }
    } finally {
      setLoading(false);
    }
  };

  useHotkeys('Enter', () => {
    if (!open || loading) return;

    submitButtonRef?.current?.click();
  });

  return (
    <Modal open={open} onClose={switchModal} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>Are you sure you want to remove this user?</div>
        <div className={styles.form}>
          <div className={styles.actionBtns}>
            <OutlinedButton onClick={handleDelete} kind="default">
              <div ref={submitButtonRef}>Yes, I am sure</div>
            </OutlinedButton>

            <ContainedButton kind="purple" onClick={switchModal}>
              No, cancel
            </ContainedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAnalystModal;
